import { PropsWithChildren, ReactNode } from 'react'
import { withShowIf } from '../../helpers/with-show-if/with-show-if.component'

export const ShowIfFragment = withShowIf(
  (props: PropsWithChildren<ReactNode>) => {
    return <>{props.children}</>
  }
)
